import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { SHARED_I18N_NAMESPACE, sharedFrFR } from "@jasper/shared";

i18n.use(initReactI18next).init({
  lng: "fr-FR",
  resources: {
    "fr-FR": { [SHARED_I18N_NAMESPACE]: sharedFrFR },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
